import {
  extensions as coreExtensions,
  type AnyExtension as TiptapExtension
} from '@tiptap/core'
import { Color } from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import Link from '@tiptap/extension-link'
import Placeholder from '@tiptap/extension-placeholder'
import Subscript from '@tiptap/extension-subscript'
import Superscript from '@tiptap/extension-superscript'
import TextAlign from '@tiptap/extension-text-align'
import { TextStyle } from '@tiptap/extension-text-style'
import Typography from '@tiptap/extension-typography'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'

import {
  getDefaultTextAlignment,
  resolveTiptapDirection
} from '@/lib/tiptap/tiptap-utils'

import type { CreateTiptapExtensionsOptions } from '@/lib/tiptap/types'

const DEFAULT_PLACEHOLDER = ''

export const createTiptapExtensions = ({
  direction,
  placeholder = DEFAULT_PLACEHOLDER
}: CreateTiptapExtensionsOptions = {}): TiptapExtension[] => {
  const resolvedDirection = resolveTiptapDirection(direction)

  return [
    coreExtensions.TextDirection.configure({
      direction: resolvedDirection === 'auto' ? undefined : resolvedDirection
    }),
    StarterKit.configure({
      bulletList: {
        HTMLAttributes: {
          class: 'list-disc'
        }
      },
      heading: {
        levels: [1, 2, 3, 4]
      },
      orderedList: {
        HTMLAttributes: {
          class: 'list-decimal'
        }
      }
    }),
    Placeholder.configure({
      emptyNodeClass: 'is-editor-empty',
      placeholder: ({ node }) => {
        switch (node.type.name) {
          case 'codeBlock':
            return ''
          case 'heading':
            return `Heading ${node.attrs.level}`
          default:
            return placeholder
        }
      }
    }),
    TextAlign.configure({
      defaultAlignment: getDefaultTextAlignment(resolvedDirection),
      types: ['heading', 'paragraph']
    }),
    TextStyle,
    Subscript,
    Superscript,
    Underline,
    Link.configure({
      autolink: true,
      defaultProtocol: 'https',
      openOnClick: false
    }),
    Color,
    Highlight.configure({
      multicolor: true
    }),
    Typography
  ]
}
